import { WSTableColumnSortDirection } from "@wingspanhq/fe-component-library";
import { ApiSortDirection } from "../../utils/serviceHelper";

export function getApiDirectionFromTable(
  direction?: WSTableColumnSortDirection
): ApiSortDirection {
  switch (direction) {
    case "ascending":
      return "asc";
    case "descending":
      return "desc";
    default:
      return undefined;
  }
}
